// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.selectMediaCategotryAdd {
    cursor: pointer;
    width: 100%;
    border: 1px dashed #ced4da;
    border-radius: 15px;
    background-color: rgb(248 248 248);
    padding-left: 40%;
    padding-top: 30px;
}

.selectinputfileCategoryAdd {
    opacity: 0;
    width: 100%;
    cursor: pointer;
}

.cancelButton {
    width: 15%;
    margin-left: 20px;
    background: #f3f3f3;
    border-color: #f3f3f3;
    color: #8a909d;
    padding: 10px;
    border-radius: 10px;
}

.addButton {
    width: 15%;
    color: #ffffff;
    background-color: var(--admin-color);
    border-color: var(--admin-color);
    padding: 10px;
    border-radius: 10px;
}

.searchheight {
    height: 50px !important;
}

.input-group span i {
    display: flex;
    justify-content: center;
    align-items: center;
}

.product_search_icon {
    background-color: none;
    border-radius: none;
    width: 40px;
    border-top-right-radius: 5px;
    border-bottom-right-radius: 5px;
}

.productDropDown {
    display: flex;
    align-items: center;
}

.productDropDown span {
    margin-left: 10px;
}

.seletedLineItem {
    background-color: #f9fafb;
}

.searchList {
    background: #f8f9fa;
    border: 1px solid #dee2e6;
    border-radius: 4px;
    padding: 10px;
    margin-bottom: 8px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    cursor: move;
    transition: background-color 0.2s ease;
}

.searchList:hover {
    background-color: #e9ecef;
}

.removeProduct {
    cursor: pointer;
    color: #dc3545;
    font-size: 18px;
}`, "",{"version":3,"sources":["webpack://./src/Components/Category/CategoryAdd/CategoryAdd.css"],"names":[],"mappings":"AAAA;IACI,eAAe;IACf,WAAW;IACX,0BAA0B;IAC1B,mBAAmB;IACnB,kCAAkC;IAClC,iBAAiB;IACjB,iBAAiB;AACrB;;AAEA;IACI,UAAU;IACV,WAAW;IACX,eAAe;AACnB;;AAEA;IACI,UAAU;IACV,iBAAiB;IACjB,mBAAmB;IACnB,qBAAqB;IACrB,cAAc;IACd,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,UAAU;IACV,cAAc;IACd,oCAAoC;IACpC,gCAAgC;IAChC,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,sBAAsB;IACtB,mBAAmB;IACnB,WAAW;IACX,4BAA4B;IAC5B,+BAA+B;AACnC;;AAEA;IACI,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,mBAAmB;IACnB,yBAAyB;IACzB,kBAAkB;IAClB,aAAa;IACb,kBAAkB;IAClB,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,YAAY;IACZ,sCAAsC;AAC1C;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,eAAe;IACf,cAAc;IACd,eAAe;AACnB","sourcesContent":[".selectMediaCategotryAdd {\n    cursor: pointer;\n    width: 100%;\n    border: 1px dashed #ced4da;\n    border-radius: 15px;\n    background-color: rgb(248 248 248);\n    padding-left: 40%;\n    padding-top: 30px;\n}\n\n.selectinputfileCategoryAdd {\n    opacity: 0;\n    width: 100%;\n    cursor: pointer;\n}\n\n.cancelButton {\n    width: 15%;\n    margin-left: 20px;\n    background: #f3f3f3;\n    border-color: #f3f3f3;\n    color: #8a909d;\n    padding: 10px;\n    border-radius: 10px;\n}\n\n.addButton {\n    width: 15%;\n    color: #ffffff;\n    background-color: var(--admin-color);\n    border-color: var(--admin-color);\n    padding: 10px;\n    border-radius: 10px;\n}\n\n.searchheight {\n    height: 50px !important;\n}\n\n.input-group span i {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n}\n\n.product_search_icon {\n    background-color: none;\n    border-radius: none;\n    width: 40px;\n    border-top-right-radius: 5px;\n    border-bottom-right-radius: 5px;\n}\n\n.productDropDown {\n    display: flex;\n    align-items: center;\n}\n\n.productDropDown span {\n    margin-left: 10px;\n}\n\n.seletedLineItem {\n    background-color: #f9fafb;\n}\n\n.searchList {\n    background: #f8f9fa;\n    border: 1px solid #dee2e6;\n    border-radius: 4px;\n    padding: 10px;\n    margin-bottom: 8px;\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    cursor: move;\n    transition: background-color 0.2s ease;\n}\n\n.searchList:hover {\n    background-color: #e9ecef;\n}\n\n.removeProduct {\n    cursor: pointer;\n    color: #dc3545;\n    font-size: 18px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
